import type { StepsProps } from 'antd';
import type { ProcessSteps } from '../Types/interfaces';

type StepStatuses = NonNullable<StepsProps['items']>[number]['status'];

export const renderStatus = (
  processSteps: ProcessSteps[],
  stepName: string
): StepStatuses => {
  const step = processSteps.find((e) => e.stepName === stepName);

  if (!step) {
    console.error(
      `Step "${stepName}" was not found in processSteps!`,
      processSteps
    );
    return 'wait'; // This "return" prevents the crash
  }
  switch (
    processSteps.find((e) => e.stepName === stepName)?.stepStatus as number
  ) {
    case 0:
      return 'wait';
    case 1:
      return 'process';
    case 2:
      return 'process';
    case 3:
      return 'finish';
    default:
      return 'wait';
  }
};

export const collaborationDocumentStatus = (
  processSteps: ProcessSteps[]
): string => {
  for (let i = 0; i < processSteps.length; i++) {
    const status = renderStatus(processSteps, processSteps[i].stepName);
    if (status === 'process') {
      return processSteps[i].stepName;
    }
  }
  return 'finished';
};
